exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pokemon-border {\n  background-color: #F5F5DC;\n  border-radius: 10px;\n  border: 2px purple solid;\n  box-shadow: 10px 10px 10px silver;\n  margin: 10px;\n  padding: 25px; }\n\n.h4-style {\n  color: #E70E02;\n  font-size: 25px;\n  font-family: 'Inter', sans-serif; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ShowOnePokemon/ShowOne.styles.scss
// module id = 219
// module chunks = 0